import {Injectable} from '@angular/core';
import { AzureApiService } from "../../services/azure-api.service";
import {Observable} from "rxjs";
import {DtoCustomerSatisfactionSurveyFilter} from "./models/DtoCustomerSatisfactionSurveyFilter";
import {DtoCustomerSatisfactionSurvey} from "./models/DtoCustomerSatisfactionSurvey";

@Injectable()
export class CustomerSatisfactionSurveyService  {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'management'
    }

    public getCustomerSatisfactionSurveys = (filter: DtoCustomerSatisfactionSurveyFilter): Observable<DtoCustomerSatisfactionSurvey> => {
        return this.http.post<DtoCustomerSatisfactionSurvey>(`${this.apiUrl}/sue/customersatisfactionsurvey/`, filter);
    };
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/marketing/customer-satisfaction-survey/customer-satisfaction-survey.service.ts